import { atom } from 'recoil';

export const sessionExpiredModalState = atom<boolean>({
  key: 'sessionExpiredModalState',
  default: false
});
